import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=39f52dfb&scoped=true&"
import script from "./Promotion.vue?vue&type=script&lang=js&"
export * from "./Promotion.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=39f52dfb&scoped=true&lang=css&"
import style1 from "./Promotion.vue?vue&type=style&index=1&id=39f52dfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f52dfb",
  null
  
)

export default component.exports